import { Dispatch } from "redux";
import { ethers } from "ethers";
import { walletActions } from "stores/reducers/wallet";
import { toast } from "react-toastify";
import { modalActions } from "stores/reducers/modal";
import { truncateWalletAddress } from "utils/truncateWalletAddress";
import { isWalletConnectMethod } from "utils/isWalletConnectMethod";
import { dev } from '../../config';

export let web3Provider: ethers.providers.Web3Provider;
export let signer: ethers.providers.JsonRpcSigner;
export const jsonRpcProvider = new ethers.providers.JsonRpcBatchProvider(
  dev()
    ? 'https://data-seed-prebsc-1-s1.binance.org:8545/'
    : 'https://bsc-dataseed3.defibit.io/',
);


declare global {
  interface Window {
    ethereum: undefined | Record<string, any>;
    BinanceChain: undefined | Record<string, any>;
  }
}

export const logg = (method: ConnectWalletMethod) => async (params: any) => {
  console.log(method);
};

const connectByWeb3Provider = async (
  provider: any,
  connectMethod: ConnectWalletMethod,
  dispatch: Dispatch<any>,
  onInvalidNetwork: () => void
) => {
  web3Provider = await new ethers.providers.Web3Provider(provider, "any");

  const network = await web3Provider.getNetwork();

  // if (network.chainId !== config.NETWORK_ID) {
  //   onInvalidNetwork();
  //   dispatch(tokensActions.resetTokensBalance());
  //   return;
  // }

  localStorage.setItem("LAST_CONNECTED_WALLET", connectMethod);

  signer = web3Provider.getSigner();
  const address = await signer.getAddress();
  const balance = await signer.getBalance();

  const walletData = {
    address,
    balance: Number(balance.toString()) / Math.pow(10, 18),
    connectMethod,
    network: network.chainId,
    status: "CONNECTED",
  };

  return walletData;
};

export const connectByEthereumProvider = async (
  method: ConnectWalletMethod,
  dispatch: Dispatch
) => {
  try {
    if (window.ethereum) {
      await window.ethereum.enable();

      const onInvalidNetwork = () => {
        dispatch(walletActions.connectWalletFailure("Invalid network"));
        //addBscNetworkToMetamask();

        toast.error("Please set up Binance Smart Chain network");
      };

      window.ethereum.on("accountsChanged", async (accounts: string[]) => {
        const [address] = accounts;
        if (address) {
          // Dispatch the updateWalletAddress action to update the wallet address in the Redux state
          dispatch(walletActions.updateWalletAddress(address));

          // Reconnect and fetch wallet data after address change
          const walletData = await connectByWeb3Provider(
            window.ethereum,
            method,
            dispatch,
            onInvalidNetwork
          );
          if (walletData?.address) {
            toast.success(
              `Wallet address changed to ${truncateWalletAddress(walletData.address)}`
            );
            dispatch(walletActions.connectWalletSuccess(walletData));
          }
        } else {
          dispatch(walletActions.resetWalletState());
        }
      });

      window.ethereum.on("chainChanged", async () => {
        connectByWeb3Provider(
          window.ethereum,
          method,
          dispatch,
          onInvalidNetwork
        );
      });

      window.ethereum.on("disconnect", () => {
        dispatch(walletActions.resetWalletState());
      });

      const walletData = await connectByWeb3Provider(
        window.ethereum,
        method,
        dispatch,
        onInvalidNetwork
      );
      if (walletData?.address) {
        toast.success(
          `Wallet connected! ${truncateWalletAddress(walletData.address)}`
        );

        dispatch(walletActions.connectWalletSuccess(walletData));
        dispatch(modalActions.toggleConnectWalletModal(false));
      } else {
        // dispatch(walletActions.endWalletConnecting());  
      }
    } else {
      /* dispatch(connectWalletFailure("No provider was found"));
        dispatch(
          alertActions.warning({
            heading: "Woops... we cannot add your wallet.",
            message: "No provider was found.",
          })
        ); */
      // dispatch(walletActions.endWalletConnecting());
    }
  } catch {
    //   dispatch(connectWalletFailure("Connection to wallet failed"));
    //   dispatch(
    //     alertActions.warning({
    //       heading: "Woops... we cannot add your wallet.",
    //       message: "Please try again.",
    //     })
    //   );
    // dispatch(walletActions.endWalletConnecting());
  }
};

export const autoConnectEthereumProvider = async (dispatch: Dispatch<any>) => {
  try {
    const connectMethod = localStorage.getItem("LAST_CONNECTED_WALLET") ?? "";

    if (isWalletConnectMethod(connectMethod)) {
      if (connectMethod === "METAMASK" && window.ethereum) {
        const w3Provider: ethers.providers.Web3Provider =
          await new ethers.providers.Web3Provider(window.ethereum, "any");

        const accounts = await w3Provider.listAccounts();
        if (accounts.length > 0) {
          connectByEthereumProvider(connectMethod, dispatch);
        }
      }
      /* if (connectMethod === 'BINANCE_CHAIN' && window.BinanceChain) {
        const w3Provider: ethers.providers.Web3Provider = await new ethers.providers.Web3Provider(
          window.BinanceChain,
          'any',
        );

        const accounts = await w3Provider.listAccounts();
        if (accounts.length > 0) {
          dispatch(connectByBinanceChainProvider());
        }
      } */

      dispatch(modalActions.toggleConnectWalletModal(false));
    }
  } catch (error) {
    console.error(error);
  }
};
